export const CORPORATE_EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@innowise\.com$/;
